import React, { useState } from "react";
import { Container, Grid, Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Category from "/components/Category";
import { getNewsListUser } from "context/actions/news";
import { getDeliveryList } from "context/actions/delivery";
import { ChevronDown, ChevronUp, ExternalLink } from "react-feather";
import WysiwygViewer from "components/TextEditorViewer";
import Link from "next/link";
import Delivery from "components/Delivery";

const useStyles = makeStyles((theme) => ({
  bestType: {
    width: "100%",
    paddingBottom: 10,
  },
  buttonCheck: {
    height: 50,
    backgroundColor: "#fff",
    color: "#000",
    font: "bold 16px Tahoma",
    width: "100%",
    marginTop: 30,
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "gray",
    },
  },
  buttonCheckDelivery: {
    height: 50,
    backgroundColor: "green",
    color: "#fff",
    font: "bold 16px Tahoma",
    width: "100%",
    marginTop: 30,
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "gray",
    },
  },
  imageBox: {
    marginTop: 70,
    borderRadius: "100%",
    width: 300,
    height: 300,
    justifyContent: "center",
    backgroundImage: "url(/log.jpg)",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 10,
  },
}));

const Most = ({ linkData }) => {
  const classes = useStyles();
  const [value, setValue] = useState("");
  const [data, setData] = useState([]);
  const [locationData, setLocation] = useState([]);
  const [deliveryData, setDelivery] = useState([]);
  const [check, setCheck] = useState(0);

  const [isDeliveryOpen, setIsDeliveryOpen] = useState(false);

  const handleDelivery = async () => {
    try {
      const res = await getDeliveryList(data[0].name);

    


      if (res.status === "success") {
        // res.data-д ямар property байгаа нь тодорхойлох хэрэгтэй
        // Жишээ нь: res.data.list
        setDelivery(res.data); // эсвэл setDelivery(res.data.list)
      }

      setIsDeliveryOpen(true);
    } catch (error) {
      console.error("Delivery fetch error:", error);
    }
  };

  // const handleDelivery = () => {
  //   const res = await getDeliveryList(value, 1);
  //     if (res.status === "success") {
  //       setDelivery(res.data.);
  //     }
  //   setIsDeliveryOpen(true);
  // };

  const handleClose = () => {
    setIsDeliveryOpen(false);
  };

  const onChangeName = (event) => {
    setValue(event.target.value); // Update the state with the new input value
  };
  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  const getInitData = async () => {
    try {
      const res = await getNewsListUser(value, 1);
      if (res.status === "success") {
        setData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleButtonClick = async () => {
    if (!value.trim()) {
      // Check if the input is empty
      alert("Утас эсвэл Дансны дугаар аа оруулна уу"); // Alert message for empty input
      return; // Prevent further execution if the input is empty
    }
    await getInitData();
    setCheck(1);
  };

  const [visibleSections, setVisibleSections] = useState({});

  const toggleSectionVisibility = (section) => {
    setVisibleSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <Container maxWidth="xxl" className="mt-[20px]">
      <Box className={classes.bestType}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={6} lg={4}>
            <Box style={{ paddingTop: 20, paddingBottom: 0, borderRadius: 5 }}>
              <input
                type="text"
                value={value}
                onChange={onChangeName}
                style={{
                  width: "100%",
                  height: 50,
                  // border: "1px solid ",
                  padding: 12,
                  borderRadius: 20,
                  font: "normal 18px Tahoma",
                  marginBottom: 20,
                }}
                placeholder="Дансны дугаараа оруулна уу"
              />
              <Category data={data} checkType={check} />{" "}
              {/* Pass the updated data to Category */}
              <Button
                className={classes.buttonCheck}
                onClick={handleButtonClick}
              >
                Илгээмж шалгах
              </Button>
              {/* {data.length > 0 && (
                <Button
                  className={classes.buttonCheckDelivery}
                  onClick={handleDelivery}
                >
                  Хүргэлтээр авах
                </Button>
              )} */}
              {/* {isDeliveryOpen && (
                <Delivery
                  open={isDeliveryOpen}
                  data={data}
                  delivered={deliveryData.data}
                  handleClose={handleClose}
                />
              )} */}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Most;
